import { render, staticRenderFns } from "./table.taxPP36.vue?vue&type=template&id=2153d8d4&scoped=true"
import script from "./table.taxPP36.vue?vue&type=script&lang=js"
export * from "./table.taxPP36.vue?vue&type=script&lang=js"
import style0 from "./table.taxPP36.vue?vue&type=style&index=0&id=2153d8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153d8d4",
  null
  
)

export default component.exports